import { formatRevenueCompact } from './formatters'

// Muted second line inside a grid cell: YTD actuals · % of the cell's target.
export default function YtdLine({ ytd, target, currency }: { ytd: number; target: number; currency?: string | null }) {
  if (ytd <= 0) return null
  return (
    <div className="text-[11px]" style={{ color: 'var(--muted-foreground)' }}>
      {formatRevenueCompact(ytd, currency)}
      {target > 0 ? ` · ${Math.round((ytd / target) * 100)}%` : ''}
    </div>
  )
}
